module.exports = __webpack_public_path__ + "img/ic_info-24px.c6278c9a.svg";